import { apiInstagramChat as http } from '../../../http';

class TemplateService {
  constructor() {}

  async getAllTemplates() {
    return http.get('/templates?userLogin=adm&isLimited=false');
  }

  async getTemplateById(id) {
    return http.get(`/templates/${id}`);
  }

  async toggleTemplateStatus(id, status) {
    return http.put('/templates/toggle', { id, status });
  }

  async updateTemplateMedia(data) {
    return http.put('/templates/media', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
}

export default new TemplateService();
